const mapStateToProps = () => ({})

export default mapStateToProps
